module.exports = __webpack_public_path__ + "static/media/fleet.66d067a4.png";